"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@8base/utils");
const jwt_decode_1 = __importDefault(require("jwt-decode"));
/**
 * Creates instance of the web oauth client
 */
class WebOAuthClient {
    constructor(options, storageOptions = {}) {
        utils_1.throwIfMissingRequiredParameters(['authorize'], utils_1.PACKAGES.WEB_AUTH0_AUTH_CLIENT, options);
        this.storageAPI = new utils_1.StorageAPI(storageOptions.storage || window.localStorage, storageOptions.storageKey || 'auth', storageOptions.initialState);
        this.options = options;
    }
    setState(state) {
        this.storageAPI.setState(state);
    }
    getState() {
        return this.storageAPI.getState();
    }
    purgeState() {
        this.storageAPI.purgeState();
    }
    checkIsAuthorized() {
        const { token } = this.getState();
        return token !== '' && token !== null && token !== undefined;
    }
    getTokenInfo() {
        const { token } = this.getState();
        if (!token) {
            return undefined;
        }
        return jwt_decode_1.default(token) || undefined;
    }
    authorize(...args) {
        return this.options.authorize.apply(this, args);
    }
    logout(...args) {
        if (typeof this.options.logout === 'function') {
            return this.options.logout.apply(this, args);
        }
    }
}
exports.WebOAuthClient = WebOAuthClient;
//# sourceMappingURL=WebOAuthClient.js.map